import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { MenuQuery } from 'app/query/menu-query';
import { map, take } from 'rxjs/operators';
import { MenuGraphql } from 'app/model/menu';
import { hashString } from 'app/shared/helpers/utils';
import { constUrpi } from 'app/shared/helpers/constants';

@Injectable({
  providedIn: 'root'
})
export class GraphqlMenuService {

  constructor(
    private apollo: Apollo) { }

  getMenu(codigoUsuario: String) {
    return (this.apollo.watchQuery<MenuGraphql>({
      query: MenuQuery.MENU_TYPE_QUERY
    }).valueChanges.pipe(map(res => { return res.data.obtenerMenus }))).pipe(take(1))
  }

  obtenerRolesPorMenu(codigoUsuario: String) {
    return (this.apollo.watchQuery<MenuGraphql>({
      query: MenuQuery.OBTENER_ROLES_POR_MENU_TYPE_QUERY,
      variables: {
        aplicacionId: constUrpi.aplicacionId,
        hash: hashString([constUrpi.aplicacionId])
      }
    }).valueChanges.pipe(map(res => { return res.data.obtenerMenusPorRolUsuario }))).pipe(take(1))
  }
}
